import { FormLabel, styled } from '@mui/material'

export const TextFieldLabel = styled(FormLabel)`
  display: block;
  font-weight: 400;
  color: ${(props) => props.theme.palette.text.primary};
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  margin-bottom: ${(props) => props.theme.typography.pxToRem(4)};
  line-height: 1.5;
`